import apiClient from './client';

// Diseases and findings share one API. `kind` is the path segment, "diseases" or
// "findings" (see toApiKind in constants/entityTypes.js). `maxKnowledge` is the
// experience filter: null (or 9) means no filter.

const filterParams = (maxKnowledge) => (maxKnowledge ? { max_knowledge: maxKnowledge } : {});

export const getRoots = (kind, maxKnowledge) =>
  apiClient
    .get(`/${kind}/roots`, { params: filterParams(maxKnowledge) })
    .then((r) => r.data.items);

export const getChildren = (kind, id, maxKnowledge) =>
  apiClient
    .get(`/${kind}/${id}/children`, { params: filterParams(maxKnowledge) })
    .then((r) => r.data.items);

// Never filtered
export const getParents = (kind, id) =>
  apiClient.get(`/${kind}/${id}/parents`).then((r) => r.data.items);

// Every root-to-node path, each a list of {id, name}
export const getPaths = (kind, id) =>
  apiClient.get(`/${kind}/${id}/paths`).then((r) => r.data.paths);

// `exclude` is the IDs already picked, sent as one comma-separated value
export const searchNodes = (kind, q, { exclude = [], maxKnowledge } = {}) =>
  apiClient
    .get(`/${kind}`, {
      params: {
        q,
        ...(exclude.length > 0 ? { exclude: exclude.join(',') } : {}),
        ...filterParams(maxKnowledge),
      },
    })
    .then((r) => r.data.items);

// Node detail: knowledge stats, flag counts, creator, `mine`, and for a disease
// its prevalence and incidence
export const getNode = (kind, id) => apiClient.get(`/${kind}/${id}`).then((r) => r.data);

// {name, description, parent_ids, child_ids}, created in one transaction
export const createNode = (kind, payload) =>
  apiClient.post(`/${kind}`, payload).then((r) => r.data);

// Only the changed fields, of {name, description}
export const updateNode = (kind, id, payload) =>
  apiClient.patch(`/${kind}/${id}`, payload).then((r) => r.data);

// Children with no other parent become roots
export const deleteNode = (kind, id) => apiClient.delete(`/${kind}/${id}`).then(() => undefined);

// One link per request, child first: to put C under P, linkParent(kind, C, P).
// A link that would make a cycle is a 409.
export const linkParent = (kind, childId, parentId) =>
  apiClient.put(`/${kind}/${childId}/parents/${parentId}`).then(() => undefined);

export const unlinkParent = (kind, childId, parentId) =>
  apiClient.delete(`/${kind}/${childId}/parents/${parentId}`).then(() => undefined);
